import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { TaxedMoney } from "@components/containers";
import { Thumbnail } from "@components/molecules";
import cartImage from "images/cart.svg";
import shareImage from "images/share.svg";
import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import Media from "react-media";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import ReactSVG from "react-svg";
import * as S from "./styles";
import { ProductListItemAttributes } from "../../../../components/OverlayManager/Cart/ProductListItemAttributes";
export var WishlistTile = function WishlistTile(_ref) {
  var _wishlistItem$variant, _wishlistItem$variant2, _wishlistItem$product, _wishlistItem$variant3, _wishlistItem$variant4, _wishlistItem$variant5, _wishlistItem$variant6;

  var addToCart = _ref.addToCart,
      editUrl = _ref.editUrl,
      remove = _ref.remove,
      share = _ref.share,
      wishlistItem = _ref.wishlistItem;
  var history = useHistory();
  var price = (_wishlistItem$variant = wishlistItem.variant) === null || _wishlistItem$variant === void 0 ? void 0 : (_wishlistItem$variant2 = _wishlistItem$variant.pricing) === null || _wishlistItem$variant2 === void 0 ? void 0 : _wishlistItem$variant2.price;
  var intl = useIntl();
  var productAttributesWithData = (wishlistItem === null || wishlistItem === void 0 ? void 0 : (_wishlistItem$product = wishlistItem.productAttributes) === null || _wishlistItem$product === void 0 ? void 0 : _wishlistItem$product.map(function (item) {
    var _item$attribute, _item$attribute$value, _item$attribute$trans;

    var valuesData = item === null || item === void 0 ? void 0 : (_item$attribute = item.attribute) === null || _item$attribute === void 0 ? void 0 : (_item$attribute$value = _item$attribute.values) === null || _item$attribute$value === void 0 ? void 0 : _item$attribute$value.filter(function (value) {
      var _item$values;

      return (_item$values = item.values) === null || _item$values === void 0 ? void 0 : _item$values.includes((value === null || value === void 0 ? void 0 : value.name) || null);
    });
    return {
      id: item === null || item === void 0 ? void 0 : item.attribute.id,
      name: item === null || item === void 0 ? void 0 : item.attribute.name,
      translatedName: item === null || item === void 0 ? void 0 : (_item$attribute$trans = item.attribute.translation) === null || _item$attribute$trans === void 0 ? void 0 : _item$attribute$trans.name,
      values: (valuesData === null || valuesData === void 0 ? void 0 : valuesData.map(function (value) {
        var _value$translation;

        return {
          name: value === null || value === void 0 ? void 0 : value.name,
          translatedName: value === null || value === void 0 ? void 0 : (_value$translation = value.translation) === null || _value$translation === void 0 ? void 0 : _value$translation.name
        };
      })) || []
    };
  }).filter(function (el) {
    return el.values.length > 0;
  })) || [];
  var variantAttributesWithData = (wishlistItem === null || wishlistItem === void 0 ? void 0 : (_wishlistItem$variant3 = wishlistItem.variant) === null || _wishlistItem$variant3 === void 0 ? void 0 : _wishlistItem$variant3.attributes.map(function (item) {
    var _item$attribute$trans2;

    return {
      id: item.attribute.id,
      name: item.attribute.name,
      translatedName: (_item$attribute$trans2 = item.attribute.translation) === null || _item$attribute$trans2 === void 0 ? void 0 : _item$attribute$trans2.name,
      values: item.values.map(function (value) {
        var _value$translation2;

        return {
          name: value === null || value === void 0 ? void 0 : value.name,
          translatedName: value === null || value === void 0 ? void 0 : (_value$translation2 = value.translation) === null || _value$translation2 === void 0 ? void 0 : _value$translation2.name
        };
      })
    };
  })) || [];
  var allAttributes = useMemo(function () {
    return [].concat(_toConsumableArray(productAttributesWithData), _toConsumableArray(variantAttributesWithData));
  }, [productAttributesWithData, variantAttributesWithData]);
  return React.createElement(S.Wrapper, {
    onClick: function onClick() {
      return history.push(editUrl);
    }
  }, React.createElement(S.Image, null, React.createElement(Link, {
    to: editUrl
  }, React.createElement(S.Pencil, null)), React.createElement("button", {
    type: "button",
    onClick: function onClick(e) {
      e.stopPropagation();
      remove();
    }
  }, React.createElement(S.Remove, null)), wishlistItem.variant && React.createElement(Thumbnail, {
    source: wishlistItem.variant.product
  })), React.createElement(S.Bottom, null, React.createElement(S.Title, null, ((_wishlistItem$variant4 = wishlistItem.variant) === null || _wishlistItem$variant4 === void 0 ? void 0 : (_wishlistItem$variant5 = _wishlistItem$variant4.product.translation) === null || _wishlistItem$variant5 === void 0 ? void 0 : _wishlistItem$variant5.name) || ((_wishlistItem$variant6 = wishlistItem.variant) === null || _wishlistItem$variant6 === void 0 ? void 0 : _wishlistItem$variant6.product.name)), React.createElement(S.Price, null, React.createElement(TaxedMoney, {
    taxedMoney: price
  })), allAttributes.length ? React.createElement(S.AttributesWrapper, null, React.createElement(ProductListItemAttributes, {
    attributes: allAttributes,
    withBlockDisplayedAttributes: true
  })) : React.createElement(S.Placeholder, null), React.createElement(S.Buttons, null, React.createElement(S.AddButton, {
    className: "red",
    onClick: function onClick(e) {
      e.stopPropagation();
      addToCart();
    }
  }, React.createElement(Media, {
    queries: {
      small: "(max-width: 1365px)"
    }
  }, function (matches) {
    return matches.small ? intl.formatMessage(_defineProperty({
      defaultMessage: "+Add",
      "id": "@next.components.molecules.WishlistTile.WishlistTile.3087799523"
    }, "id", "@next.components.molecules.WishlistTile.WishlistTile.3087799523")) : intl.formatMessage(_defineProperty({
      defaultMessage: "Add to cart",
      "id": "@next.components.molecules.WishlistTile.WishlistTile.1456701921"
    }, "id", "@next.components.molecules.WishlistTile.WishlistTile.1456701921"));
  }), React.createElement(ReactSVG, {
    path: cartImage
  })), React.createElement(S.ShareButton, {
    className: "light-red",
    onClick: function onClick(e) {
      e.stopPropagation();
      share();
    }
  }, React.createElement(ReactSVG, {
    path: shareImage
  })))));
};